import { tv } from "../foundations/cn.js";
import { FOCUS_RING, PRESS, PRESS_SCALE_SMALL } from "../foundations/interaction.js";

/** Icon button looks; Modal's close button wears them too. */
export const iconButtonStyles = tv({
  base: [
    "inline-flex shrink-0 cursor-pointer items-center justify-center rounded-control text-text-primary",
    "not-data-disabled:hover:bg-bg-hover not-data-disabled:active:bg-bg-pressed data-disabled:cursor-default data-disabled:text-text-disabled",
    PRESS,
    PRESS_SCALE_SMALL,
    FOCUS_RING,
  ],
  variants: {
    variant: {
      secondary: "bg-bg-raised data-disabled:bg-bg-surface",
      ghost: "text-text-secondary not-data-disabled:hover:text-text-primary",
      glass: "glass",
    },
    size: {
      xs: "size-control-xs",
      sm: "size-control-sm",
      md: "size-control-md",
      lg: "size-control-lg",
    },
    /** The on state changes fill, edge and icon, so it never rests on color alone. */
    toggle: {
      true: "border border-transparent data-pressed:border-accent-default data-pressed:bg-accent-subtle data-pressed:text-accent-text",
    },
  },
  compoundVariants: [
    // A ghost toggle has no edge or fill to change: its icon carries the on state (a heart that
    // fills in), so the caller gives the icon a pressed form.
    {
      variant: "ghost",
      toggle: true,
      class: "border-0 data-pressed:bg-transparent not-data-disabled:hover:bg-transparent",
    },
  ],
  defaultVariants: { variant: "secondary", size: "md" },
});
